import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type SummaryData = {
  this_weeks_scheduled_events: number;
  upcoming_unscheduled_events: number;
  upcoming_scheduled_events: number;
  active_employees: number;
  active_accounts: number;
};

export const fetchSummary = async (): Promise<SummaryData> => {
  const response = await CustomAxios.get<SummaryData>('/dashboard/status');
  return response.data;
};

export const useGetDashboardSummary = () => {
  return useQuery({
    queryKey: [queryKeys.dashboardSummary],
    queryFn: fetchSummary,
  });
};
